module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor06-49d55e047650a2ac9a316c4eb42a2437.pdf";